/*
 *
 * OperationSummary
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 01-Jul-2024
 */
import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  terminalId: <PortalMessage id='t.app.orders.operation.summary.terminalID' defaultMessage='Terminal ID (TML)' />,
  operationAmount: <PortalMessage id='t.app.orders.operation.summary.amount' defaultMessage='Operation Amount' />,
  orderId: <PortalMessage id='t.app.orders.operation.summary.OrderID' defaultMessage='Order ID' />,
  operationId: <PortalMessage id='t.app.orders.operation.summary.operationID' defaultMessage='OID' />,
  channel: <PortalMessage id='t.app.orders.operation.summary.Channel' defaultMessage='Channel' />,
  operationType: <PortalMessage id='t.app.orders.operation.summary.OperationType' defaultMessage='Operation' />,
  operationResult: <PortalMessage id='t.app.orders.operation.summary.Status' defaultMessage='Status' />,
  operationTime: <PortalMessage id='t.app.orders.operation.summary.date' defaultMessage='Date and time' />,
  paymentMethod: <PortalMessage id='t.app.orders.operation.summary.paymentMethod' defaultMessage='Payment Method' />,
  paymentInstrument: (
    <PortalMessage id='t.app.orders.operation.summary.paymentInstrument' defaultMessage='Payment Instrument' />
  ),
  paymentEndToEndId: (
    <PortalMessage id='t.app.orders.operation.summary.paymentEndToEndId' defaultMessage='End to End ID' />
  )
}

export const messages = defineMessages({
  actionNotFound: {
    id: 't.app.orders.operation.notFound',
    defaultMessage: 'Action not found'
  },
  AUTHORIZATION: {
    id: 't.app.operationsmanagement.operationType.authorization',
    defaultMessage: 'AUTHORIZATION'
  },
  CAPTURE: {
    id: 't.app.operationsmanagement.operationType.capture',
    defaultMessage: 'CAPTURE'
  },
  REFUND: {
    id: 't.app.operationsmanagement.operationType.refound',
    defaultMessage: 'REFUND'
  },
  CANCEL: {
    id: 't.app.operationsmanagement.operationType.cancel',
    defaultMessage: 'CANCEL'
  },
  NOSHOW: {
    id: 't.app.operationsmanagement.operationType.noShow',
    defaultMessage: 'NO SHOW'
  },
  INCREMENTAL: {
    id: 't.app.operationsmanagement.operationType.incremental',
    defaultMessage: 'INCREMENTAL'
  },
  DELAY_CHARGE: {
    id: 't.app.operationsmanagement.operationType.delayCharge',
    defaultMessage: 'DELAY CHARGE'
  },
  CARD_VERIFICATION: {
    id: 't.app.operationsmanagement.operationType.cardverification',
    defaultMessage: 'CARD VERIFICATION'
  },
  CARD_CHECK: {
    id: 't.app.operationsmanagement.operationType.cardcheck',
    defaultMessage: 'CARD CHECK'
  },
  VOID: {
    id: 't.app.operationsmanagement.operationType.void',
    defaultMessage: 'VOID'
  },
  AUTHORIZED: {
    id: 't.app.operationsmanagement.status.authorized',
    defaultMessage: 'AUTHORIZED'
  },
  EXECUTED: {
    id: 't.app.operationsmanagement.status.executed',
    defaultMessage: 'EXECUTED'
  },
  DECLINED: {
    id: 't.app.operationsmanagement.status.declined',
    defaultMessage: 'DECLINED'
  },
  DENIED_BY_RISK: {
    id: 't.app.operationsmanagement.status.deniedByRisk',
    defaultMessage: 'DENIED BY RISK'
  },
  DENIED: {
    id: 't.app.operationsmanagement.status.denied',
    defaultMessage: 'DENIED'
  },
  THREEDS_VALIDATED: {
    id: 't.app.operationsmanagement.status.threedsValidated',
    defaultMessage: 'THREEDS VALIDATED'
  },
  THREEDS_FAILED: {
    id: 't.app.operationsmanagement.status.threedsFailed',
    defaultMessage: 'THREEDS FAILED'
  },
  PENDING: {
    id: 't.app.operationsmanagement.status.pending',
    defaultMessage: 'PENDING'
  },
  CANCELED: {
    id: 't.app.operationsmanagement.status.canceled',
    defaultMessage: 'CANCELED'
  },
  REFUNDED: {
    id: 't.app.operationsmanagement.status.refunded',
    defaultMessage: 'REFUNDED'
  },
  FAILED: {
    id: 't.app.operationsmanagement.status.failed',
    defaultMessage: 'FAILED'
  },
  VOIDED: {
    id: 't.app.operationsmanagement.status.voided',
    defaultMessage: 'VOIDED'
  },
  CARD: {
    id: 't.app.operationsmanagement.payMethod.card',
    defaultMessage: 'CARD'
  },
  OCT: { 
    id: 't.app.operationsmanagement.operationType.payToCard',
    defaultMessage: 'PAY-TO-CARD'
  },
})

export default formattedMessage
